import { serializeQuery } from "@/utils/UrlUtils";
import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiSequences {
  static getSequences(appId, params, { signal } = {}) {
    const query = serializeQuery(params);
    return apiFetch(`${ApiBaseUrl}apps/${appId}/sequences?${query}`, { signal });
  }

  static createSequence(appId, sequence) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/sequences`, {
      method: "POST",
      body: sequence,
    });
  }

  static createSequenceFromTemplate(appId, sequence) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/sequences/create_from_template`, {
      method: "POST",
      body: sequence,
    });
  }

  static getSequence(appId, sequenceId, params) {
    const query = serializeQuery(params);
    return apiFetch(`${ApiBaseUrl}apps/${appId}/sequences/${sequenceId}?${query}`);
  }

  static deleteSequence(appId, sequenceId, sequence) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/sequences/${sequenceId}`, {
      method: "DELETE",
      body: sequence,
    });
  }

  static updateSequence(appId, sequenceId, sequence) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/sequences/${sequenceId}`, {
      method: "PUT",
      body: sequence,
    });
  }

  static cloneSequence(appId, sequenceId, engagementCategory = null) {
    const body = engagementCategory ? { engagement_category: engagementCategory } : {};
    return apiFetch(`${ApiBaseUrl}apps/${appId}/sequences/${sequenceId}/clone`, {
      method: "POST",
      body,
    });
  }

  static cloneSequenceToApp(
    appId,
    sequenceId,
    targetAppId,
    defaultCompany,
    engagementCategory = null,
  ) {
    const endpoint = defaultCompany ? "clone_to_app" : "clone_to_company";
    const query = serializeQuery({ clone_app_id: targetAppId });
    const body = engagementCategory ? { engagement_category: engagementCategory } : {};
    return apiFetch(`${ApiBaseUrl}apps/${appId}/sequences/${sequenceId}/${endpoint}?${query}`, {
      method: "POST",
      body,
    });
  }

  static bulkUpdate(appId, guides) {
    if (!guides?.length) throw new Error("Expected second parameter to be a non empty array");

    return apiFetch(`${ApiBaseUrl}apps/${appId}/sequences/bulk_update`, {
      method: "PUT",
      body: { sequences: guides },
    });
  }

  static bulkDelete(appId, guides) {
    if (!guides?.length) throw new Error("Expected second parameter to be a non empty array");

    return apiFetch(`${ApiBaseUrl}apps/${appId}/sequences/bulk_delete`, {
      method: "DELETE",
      body: { sequences: guides },
    });
  }
}
